<template>
  <div>


 <el-table :data="DataList"  style="width: 100%" :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{ textAlign: 'center'}"
      :row-style="{background:'#F5F7FA'}">


        <el-table-column prop="dealNo" label="订单编号" width="120px">
        </el-table-column>
        <el-table-column prop="prodName" label="商品名称">
          <template slot-scope="scope" >

           <span @click="jump(scope.row.prodId)"
           style="color:darkgreen;cursor:pointer;"
           >{{scope.row.prodName}}</span>

          </template>
        </el-table-column>
        <el-table-column prop="amount" label="总价">
          <template slot-scope="scope">
            {{scope.row.amount}}元
          </template>
        </el-table-column>
       <el-table-column  label="单价" width="120px">
         <template slot-scope="scope">
           {{scope.row.price}}
               <span v-if="scope.row.priceUnit==2">元/kg</span>
                   <span v-if="scope.row.priceUnit==3">元/份</span>
         </template>
       </el-table-column>

       <el-table-column  label="订单状态" width="120px">
         <template slot-scope="scope">
               <span v-if="scope.row.dataStatus==0">待发货</span>
              <span v-if="scope.row.dataStatus==1">已发货</span>
              <span v-if="scope.row.dataStatus==2">交易成功</span>
              <span v-if="scope.row.dataStatus==3">订单关闭</span>
         </template>
       </el-table-column>

        <el-table-column fixed="right" label="操作" width="300px">
          <template slot-scope="scope">
            <el-button type="success"  @click="showOrderDetail(scope.row)" size="small" plain>查看详情
            </el-button>
            <el-button  v-if="scope.row.payImage==null" type="danger"   @click="showUpload(scope.row)"  size="small" plain>上传转账截图
            </el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="tabListPage">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
          :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>


      <el-dialog title="填写基本信息" :visible.sync="uploadPayImgModalFlag" width="80%" :before-close="handleClose" append-to-body>
        <div style="width: 100%;height: 500px;">
          <el-form ref="signUp" :model="currentOrder" :inline="true" label-width="100px" style="margin-top: 10px;">

              <el-col :span="12">
                <el-form-item label="转账截图" label-width="150px">
                  <el-upload class="upload-demo" action="http://36.133.43.44:8547/api/web/upload"
                    :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                    :on-success="getUploadPayImgReverse" multiple :limit="1" :on-exceed="handleExceed"
                    :file-list="uploadOrderPayImgList">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                  </el-upload>
                </el-form-item>
              </el-col>

            <el-button type="primary" @click="savePayImg()" icon="el-icon-check" style="margin-left: 31%;width:300px">提交
            </el-button>

          </el-form>

        </div>
      </el-dialog>


      <el-dialog title="订单信息" :visible.sync="orderDetailModal" width="80%" :before-close="handleClose" append-to-body>
        <div style="width: 100%;height: 500px;">
          <el-form ref="signUp" :model="currentOrder" :inline="true" label-width="100px" style="margin-top: 10px;">

              <el-col :span="12">
                <el-form-item label="订单编号:" label-width="150px">
                  {{currentOrder.dealNo}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="订单编号:" label-width="150px">
                  {{currentOrder.dealNo}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商品名称:" label-width="150px">
                  {{currentOrder.prodName}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商品单价:" label-width="150px">
                  {{currentOrder.price}}<span v-if="currentOrder.priceUnit==2">元/kg</span>
                   <span v-if="currentOrder.priceUnit==3">元/份</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="订单总额:" label-width="150px">
                  {{currentOrder.amount}}元
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="快递编号:" label-width="150px">
                  {{currentOrder.expressNo}}
                </el-form-item>
              </el-col>

              <el-col :span="12" >
                <el-form-item label="收货地址:" label-width="150px">
                  {{currentOrder.address}}
                </el-form-item>
              </el-col>
              <el-col :span="12" >
                <el-form-item label="收货人:" label-width="150px">
                  {{currentOrder.name}}
                </el-form-item>
              </el-col>


              <el-col :span="12" v-if="currentOrder.images!=null" >
                <el-form-item label="商品图片:" label-width="150px">
                  <img  :src="item" v-for="(item,index) in  currentOrder.images.split(',')" style="width:200px;height:200px"/>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="currentOrder.images!=null" >
                <el-form-item label="转账截图:" label-width="150px">
                  <img  :src="currentOrder.payImage"  style="width:200px;height:200px"/>
                </el-form-item>
              </el-col>



          </el-form>

        </div>
      </el-dialog>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        unitCode: "410800000000",
        pageNum: 1, // 默认显示第几页
        totalCount: 1, // 总条数，根据接口获取数据长度(注意：这里不能为空)
        pageSizes: [5, 10, 15, 20], // 个数选择器（可修改）
        pageSize: 10, // 默认每页显示的条数（可修改）
        DataList: [],
        countys:[],
        towns:[],
        villages:[],
        uploadPayImgModalFlag:false,
        currentOrder:{},
        uploadOrderPayImg:"",
        uploadOrderPayImgList:[],
        orderDetailModal:false,
      }
    },
    created() {
      this.getData();
    },
    methods: {
      showOrderDetail(order){
        this.currentOrder=order;
        this.orderDetailModal=true;
      },
      showUpload(order){
         this.currentOrder=order;
         this.uploadPayImgModalFlag=true;
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {},
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      jump(ids){
        this.$router.push({
              name: 'productDetail',
              query: {
                id: ids
              }
            })
      },
      getUploadPayImgReverse(response, file, fileList) {
        console.log(response)
        this.uploadOrderPayImg = response.data;
      },
      savePayImg(){
        var  data={"id":this.currentOrder.id,"imageUrl":this.uploadOrderPayImg};

        this.$http.post("/web/order/uploadOrderPayImage",data).then((res) => {
          if (res.data.msg == "success") {

            this.$message.success("转账截图上传成功！");

            this.uploadPayImgModalFlag = false;
            this.getData();
          } else {
            this.$message.success(res.data.msg)
          }

        });
      },

      async getData() {

        var num = this.pageNum;
        const {
          data: res
        } = await this.$http.get('/web/order/queryList?pageNum=' + num + "&pageSize=" + this
          .pageSize );
        this.DataList = res.data.list;
        this.totalCount = res.data.total;
        console.log(res);
      },


      // 每页显示的条数，选择每页条数的时候执行
      handleSizeChange(val) {
        this.pageSize = val // 改变每页显示的条数
        this.searchData(this.searchUnitCode);
        this.pageNum = 1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
      },
      // 显示第几页
      handleCurrentChange(val) {
        console.log("handleCurrentChange")
        this.pageNum = val; // 改变默认的页数
        this.searchData(this.searchUnitCode);
      },

    },


  }
</script>

<style lang="scss" scoped="">
  .select {
    width: 60%;
    height: 40px;
    border-color: #dcdfe6;
  }

  .selectAdd {
    width: 60%;
    height: 40px;
    border-color: #dcdfe6;
  }

  .lable {
    width: 83px;
    color: black;
    font-size: 15px;
    float: left;
    line-height: 40px;
    text-align: right;
  }

  .inp {
    width: 48%;
    height: 32px;
    border: 1px solid #ccc;

  }



  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>
